import glo from '../../main'
import { tkParse } from '@moke/vue-tk'
export default {
  className: 'floor',
  render: (residentialQuarters) => {
    return `${residentialQuarters.name}`
  },
  fields: [
    {
      name: 'name',
      validators: [
        (val) => val ? null : '楼号不可为空'
      ]
    }
  ],
  hooks: {
    async beforeInsert ({ data }) {
      const { data: res } = await tkParse.get(`/classes/floor`, {
        params: {
          where: {
            name: data.name
          }
        }
      })
      if (res.results.length) {
        throw new Error('楼号已存在')
      }
    }
  },
  action: {
    // edit: false,
    // delete: false,
    download: {
      type: 'list',
      text: '下载模板',
      callback: async function () {
        window.open('https://moke-runji.oss-cn-beijing.aliyuncs.com/3dd00b0b-d4e3-4c8d-bbc5-882ae11eb3b5.xlsx', '_blank')
      }
    },
    imports: {
      type: 'list',
      icon: 'import',
      text: '导入',
      callback: async function imports ({ vm }) {
        try {
          const excel = await glo.$excel.pick()
          const exceldata = excel.toJson()
          console.log(exceldata)
          glo.$loading.show()
          for (let i = 0; i < exceldata.Sheet1.length; i++) {
            const element = exceldata.Sheet1[i]
            const data = element['楼号'].toString()
            const res = await tkParse.get(`/classes/floor`, {
              params: {
                where: {
                  name: data
                }
              }
            })
            if (res.data.results.length === 0) {
              await tkParse.post(`/classes/floor`, {
                name: data
              })
            } else {
              glo.$loading.hide()
              glo.$notification['error']({
                message: '操作失败',
                description: `第${i + 1}条数据已存在`
              })
              vm.refresh()
              return
            }
          }
          glo.$loading.hide()
          glo.$notification['success']({
            message: '操作成功',
            description: '数据已导入'
          })
          vm.refresh()
        } catch (e) {
          glo.$loading.hide()
          glo.$notification['error']({
            message: '操作失败',
            description: '数据格式错误'
          })
        }
      }
    }
  }
}
